import { createContext, useContext, useState, useEffect} from "react";

const featureFlagContext = createContext(undefined);

export const FeatureFlagProvider= ({ children }) => {
  const [isFeatureFlag, setFeatureFlag] = useState({});

  useEffect(() => {
    // For now, we'll provide default feature flags instead of using GraphQL
    // TODO: Replace this with a proper REST API call to your feature flag service
    const defaultFeatureFlags = {
      "Left_SlideBar": {
        show_al_chat: true,
        show_billing: true,
        show_company: true,
        show_dashboard: true,
        show_questions: true,
        show_reports: true,
        show_settings: true,
        show_vendor_supply_chain: true,
        show_request_status: true,
      },
      "Buttons": {
        show_add_company_button: true,
      },
      "Company_Page": {
        show_new_companies_list: true,
        show_recently_changed_list: true,
        show_recently_visited_list: true,
        show_risky_companies_list: true,
      }
    };
    
    setFeatureFlag(defaultFeatureFlags);
    console.log("Default feature flags loaded:", defaultFeatureFlags);
  }, []);
  

  return (
    <featureFlagContext.Provider value={{ isFeatureFlag, setFeatureFlag }}>
      {children}
    </featureFlagContext.Provider>
  );
};

export const useFeatureFlag = ()=> {
  const context = useContext(featureFlagContext);
  if (!context) {
    throw new Error("featureFlag must be used within a featureFlagProvider");
  }
  return context;
};


